module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAMAAADAMI+zAAAAWlBMVEVHcEweHh4gICAgICAgICASEhIgICAgICAhISEhISEhISEhISEgICAgICAiIiIhISEhISEAAAAiIiIhISEgICAfHx8gICAfHx8dHR0cHBwgICAhISEhISEaGhrrUtZrAAAAHnRSTlMAEUfNcA6u1hfYXdnOCDVOzwMmu9Q5IFosCWllwR0dkGLwAAAAO0lEQVQI12MQ4GOAAgluBjFOJghblFOIgYGDXRzE5meXBVGMPFIMDFwiHBAFkjIs0sysMK2CbMK8IBoARqYBzMqvi0cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/xiala.png
// module id = 89BO
// module chunks = 1